import {FEATURE_TRANSLATIONS_FIELDS} from "../shared/translations";



export const TranslationsService = {  

    getTranslations(layerName: string): {[key: string]: string} {
        return FEATURE_TRANSLATIONS_FIELDS[layerName];
    }
};
